import Swal from "sweetalert2";
import { CustomContactItem } from "./custom-contact-item";
import { ContactType } from "../../../profile/domain/contact-type";
import Header from "../../../../components/header/header";
import { BackBtn } from "../../../../components/header/btn/back-btn";
import { CompleteBtn } from "../../../../components/header/btn/complete-btn";
import { ContactItem } from "./contact-item";
import {ContactChangeStatus} from "../../index";

function ContactEdit({ serviceType, contactsUpdater, close }) {
    const isValid = () => contactsUpdater.getContacts(serviceType)
        .every((contact) => contact.title.length > 0 && contact.content.length > 0)

    const addContact = () => {
        if (isValid()) {
            const title = ContactType[serviceType].title
            contactsUpdater.add(serviceType, title, "")
            return
        }

        Swal.fire({
            title: '입력되지 않은 연락처가 있어요!',
            text: '입력되지 않은 연락처에 작성해주세요.',
            customClass: 'swal-alert',
            allowOutsideClick: false,
            confirmButtonText: '확인',
            confirmButtonColor: '#2D2D2D'
        })
    }

    const checkClose = () => {
        contactsUpdater.undoChanges(serviceType)
        close()
    }

    const checkValidAndClose = () => {
        if (isValid()) {
            close()
            return
        }

        Swal.fire({
            title: '입력되지 않은 연락처가 있어요!',
            text: '입력되지 않은 연락처를 작성하거나 삭제해주세요.',
            customClass: 'swal-alert',
            allowOutsideClick: false,
            confirmButtonText: '확인',
            confirmButtonColor: '#2D2D2D'
        })
    }

    const renderContactList = () => {
        return contactsUpdater.getContacts(serviceType).map((contact, index) => {
            if (serviceType === "WEB") {
                return <ContactItem key={index}
                    index={index}
                    contact={contact}
                    // updateTitle={contactsUpdater.updateTitle}
                    updateContent={contactsUpdater.updateContent}
                    removeContact={contactsUpdater.remove} />
            } else {
                return <ContactItem key={index}
                    index={index}
                    contact={contact}
                    updateContent={contactsUpdater.updateContent}
                    removeContact={contactsUpdater.remove} />
            }
        }
        )
    }

    return (
        <div className="Layer contact-edit-container">
            <Header>
                <BackBtn position={"left"} onClick={checkClose} />
                <CompleteBtn onClick={checkValidAndClose} />
            </Header>
            <div className="Layer-inner">
                <div className="contact-list-container">
                    {renderContactList()}
                </div>
                <div className="add-btn_wrapper" onClick={addContact}>
                    <button>
                        연락처 추가
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ContactEdit;
